import { render, staticRenderFns } from "./headInfo.vue?vue&type=template&id=bab88386&scoped=true"
import script from "./headInfo.vue?vue&type=script&lang=js"
export * from "./headInfo.vue?vue&type=script&lang=js"
import style0 from "./headInfo.vue?vue&type=style&index=0&id=bab88386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab88386",
  null
  
)

export default component.exports